import { UserTypeWisePagesConfig } from '../constant';
import { ENC_KEY_STRING, IV_STRING } from './base-urls';
import { AuthUserState } from './dto/response';
import CryptoJS from 'crypto-js';

const getEncryptionConfig = () => {
    if (!ENC_KEY_STRING || !IV_STRING) {
        throw new Error('Encryption key or IV is not defined in environment variables.');
    }
    const key = CryptoJS.enc.Utf8.parse(ENC_KEY_STRING);
    const iv = CryptoJS.enc.Utf8.parse(IV_STRING);
    return { keySize: 128, iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, key };
};

export function encryptText(plainText: any) {
    if (!plainText) return ''
    const config = getEncryptionConfig();
    let encPassword = CryptoJS.AES.encrypt(plainText, config.key, config);
    return encPassword.ciphertext.toString(CryptoJS.enc.Base64);
}

export const decryptText = (text: unknown): string => {
    if (typeof text !== 'string' || !text.trim()) return '';
    const config = getEncryptionConfig();
    try {
        const decrypted = CryptoJS.AES.decrypt(text, config.key, config);
        const result = decrypted.toString(CryptoJS.enc.Utf8);
        return result ?? text;
    } catch {
        try {
            const parsed = JSON?.parse(text);
            return typeof parsed === 'string' ? parsed : JSON.stringify(parsed);
        } catch {
            return text;
        }
    }
};

export const isObject = (obj: any) => typeof obj === 'object' && !Array.isArray(obj) && obj !== null

export const stableSort = <T>(array: readonly T[], comparator: (a: T, b: T) => number) => {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export const getComparator = <Key extends keyof any>(order: any, orderBy: Key,): (
    a: { [key in Key]: any },
    b: { [key in Key]: any },
) => number => {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

export const descendingComparator = <T>(a: T, b: T, orderBy: keyof T) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

export const isLoggedIn = (state: AuthUserState) => {
    const { token, user_details, session_expires } = state;
    return !!user_details && !!token && !!session_expires;
}


export const isAuthorizedPage = (userType: string) => {
    const path = window.location.pathname;
    return UserTypeWisePagesConfig[userType] && (UserTypeWisePagesConfig[userType].indexOf(path) > -1 || UserTypeWisePagesConfig[userType].indexOf(path + '/') > -1) ? true : false;
}

export async function aesEncrypt(plainText: string, secretKey: string): Promise<string> {
    return plainText
    // // return plainText
    // const enc = new TextEncoder();

    // // 1️⃣ Derive 256-bit key from secret
    // const keyMaterial = await crypto.subtle.importKey(
    //     "raw",
    //     enc.encode(secretKey),
    //     { name: "PBKDF2" },
    //     false,
    //     ["deriveKey"]
    // );

    // const salt = enc.encode("static-salt"); // MUST be same in Go
    // const key = await crypto.subtle.deriveKey(
    //     {
    //         name: "PBKDF2",
    //         salt,
    //         iterations: 100000,
    //         hash: "SHA-256",
    //     },
    //     keyMaterial,
    //     { name: "AES-GCM", length: 256 },
    //     false,
    //     ["encrypt"]
    // );

    // // 2️⃣ Generate IV (nonce)
    // const iv = crypto.getRandomValues(new Uint8Array(12));

    // // 3️⃣ Encrypt
    // const encrypted = await crypto.subtle.encrypt(
    //     { name: "AES-GCM", iv },
    //     key,
    //     enc.encode(plainText)
    // );

    // // 4️⃣ Combine IV + ciphertext
    // const combined = new Uint8Array(iv.length + encrypted.byteLength);
    // combined.set(iv);
    // combined.set(new Uint8Array(encrypted), iv.length);

    // // 5️⃣ Base64 encode
    // return btoa(String.fromCharCode(...combined));
}